import { render, staticRenderFns } from "./QuizSelections.vue?vue&type=template&id=a66a8464"
import script from "./QuizSelections.vue?vue&type=script&lang=js"
export * from "./QuizSelections.vue?vue&type=script&lang=js"
import style0 from "./QuizSelections.vue?vue&type=style&index=0&id=a66a8464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports